import React, { useContext } from "react";
import Styles from "./Header.module.css";
import { Link } from "react-router-dom";
import LoginContext from "./LoginContext";
import { API_BASE_URL } from "../constants/apiConfig";
const Header = () => {
  const { isloggedIn, setIsLoggedIn, userRole }: any = useContext(LoginContext);
  // const user = "Guest";
  const logOut = () => {
    // fetch("http://localhost:8001/admin/logout", {
    fetch(`${API_BASE_URL}/admin/logout`, {
      method: "POST",
      credentials: "include", // Include cookies in the request
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status > 0) {
          setIsLoggedIn(false);
        }
      });
  };
  return (
    <div>
      {/* <div className={Styles.header}>
        <div className={Styles.headerLine}>My Tutor</div>
        <div className={Styles.headerLine}>Welcome {user}</div>
      </div> */}
      <div>
        <nav className={Styles.navStyle}>
          {isloggedIn && userRole === "admin" ? (
            <>
              <Link to="/" onClick={logOut} className={Styles.linkStyle}>
                {" "}
                Logout{" "}
              </Link>
              <Link to="/allqusstats" className={Styles.linkStyle}>
                {" "}
                Analytics{" "}
              </Link>
              <Link to="/addqus" className={Styles.linkStyle}>
                {" "}
                Add ques{" "}
              </Link>
              <Link to="/listqus" className={Styles.linkStyle}>
                {" "}
                List ques{" "}
              </Link>
            </>
          ) : (
            <>
              <div className="flex flex-row flex-end justify-between">
                {
                  isloggedIn ? (
                    <Link to="/" onClick={logOut} className="link link-primary">
                      {" "}Logout{" "}
                    </Link>
                  ) : (
                    <Link to="/login" className="link link-primary">
                      {" "}Login{" "}
                    </Link>
                  )    
                }
                {/* <Link to="/login" className="link link-primary">
                  {" "}
                  Login{" "}
                </Link> */}
                <Link to="/" className="link link-primary">
                  {" "}
                  Home{" "}
                </Link>
                <Link to="/genQus" className="link link-primary">
                  {" "}
                  Start Test{" "}
                </Link>
              </div>
            </>
          )}
        </nav>
      </div>
    </div>
  );
};
export default Header;
